// extracted by mini-css-extract-plugin
export default {"container":"label_container__YPXfZ","chartLabel":"label_chartLabel__hBE+w","chartPriceLabel":"label_chartPriceLabel__NgkFY"};